'use client';

import { useContext } from 'react';
import { UiRouteModalContext } from './UiRouteModal';

export function useRouteModal() {
    const ctx = useContext(UiRouteModalContext);
    if (!ctx) {
        throw new Error('useRouteModal must be used inside <UiRouteModal>');
    }
    return ctx;
}

/** Like useRouteModal, but returns null outside a modal instead of throwing —
 *  for components that render differently depending on the modal context. */
export function useRouteModalOptional() {
    return useContext(UiRouteModalContext);
}
